(ns app.front.dashboard.my-workspaces
  (:require [app.front.search-result :as sr]
            [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.search.subs :as search-subs]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.front.session :as session]
            [re-frame.core-instrumented :as rf]))

(defn fetch-fx [db]
  (when (and (ff/enabled? :feature-flag.id/workspace-search-updates)
             (not (or (-> db :session/user :user/authority?)
                      (session/admin? (:session/user db)))))
    {:dispatch [:comm/command-monitored
                {:command    :workspace/find
                 :data       {:limit          4
                              :sort-condition [:modified :desc]}
                 :on-success [::fetch-success]}]}))

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} _]
    (fetch-fx db)))

(rf/reg-event-db ::fetch-success
  (fn [db [_ _status {:keys [results]}]]
    (assoc db ::results results)))

(rf/reg-sub ::results
  :-> ::results)

(defn dashboard-widget [tr]
  (let [results  (<sub [::results])
        loading? (<sub [:comm/command-processing? :workspace/find])]
    [:section.dashlet.bg-ui-white.rounded.p-4.md:p-6
     {:aria-labelledby "my-workspaces-title"}
     [:div.mb-4.flex.items-start.justify-between.gap-3
      [:h2#my-workspaces-title (tr [:my-workspaces/title])]
      [ui/button {:kind          :ghost
                  :size          :small
                  :icon          i/arrow-right
                  :icon-position :right
                  :class-name    "font-semibold uppercase whitespace-nowrap"
                  :on-click      #(do (>evt [::search-subs/set-search-term ""])
                                      (>evt [::search-subs/perform-search]))}
       (tr [:view-all])]]
     (cond
       loading? [:p {:role "status"} (tr [:loading])]
       (seq results)
       [:div.grid.grid-cols-1.md:grid-cols-2.xl:grid-cols-4.gap-4
        (for-frag [workspace results]
          [sr/search-result-box workspace {:compact-action? true}
           [sr/dashboard-result-footer workspace]])]
       :else [:p (tr [:my-workspaces/empty])])]))
